export default "__VITE_ASSET__DTdiWiI8__"